import styled from 'styled-components';
import colors from '../../styles/colors';

export const Container = styled.div`
  background: linear-gradient(
    180deg,
    rgba(200, 200, 200, 0.3) 0%,
    rgba(240, 240, 240, 0.5) 100%
  );
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  gap: 2rem;

  > img {
    max-height: 100px;
  }

  @media (max-width: 600px) {
    > img {
      height: auto;
      width: 180px;
    }
  }
`;

export const Content = styled.div`
  width: 450px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #fff;
  padding: 1.5rem;
  border-radius: 1rem;
  box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
  p {
    margin-top: 0.5rem;
    color: #ed4c4c;
  }

  img {
    width: 75px;
  }

  form {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 80%;
    gap: 0.5rem;
    margin-bottom: -1rem;

    > button {
      margin-top: 1rem;
    }
  }

  a {
    margin-top: 2rem;
    color: inherit;
    transition: all 0.2s;

    &:hover {
      color: ${colors.aux1};
    }
  }

  @media (max-width: 600px) {
    width: 90%;

    img {
      width: 80px;
    }

    form {
      width: 90%;
    }
  }
`;
